namespace PaperTrail.NewsletterControl {
    export interface NewsletterPageTemplateRow {
        NewsletterPageTemplateId?: number;
        NewsletterId?: number;
        PageTemplateId?: number;
        Rank?: number;
        TemplateSections?: PageTemplateSectionRow[];
        NewsletterNewsletterName?: string;
        NewsletterCreatedBy?: number;
        NewsletterDateCreated?: string;
        NewsletterDateModified?: string;
        NewsletterModifiedBy?: number;
        NewsletterPages?: number;
        NewsletterStyleSheetId?: number;
        PageTemplateTitle?: string;
        PageTemplateFileName?: string;
        PageTemplateRank?: number;
        PageTemplateAdsSpots?: number;
        PageTemplateNewsSpots?: number;
        PageTemplateIsFilled?: boolean;
        IsFrontPage?: boolean;
    }

    export namespace NewsletterPageTemplateRow {
        export const idProperty = 'NewsletterPageTemplateId';
        export const nameProperty = 'PageTemplateTitle';
        export const localTextPrefix = 'NewsletterControl.NewsletterPageTemplate';
        export const lookupKey = 'NewsletterControl.NewsletterPageTemplate';

        export function getLookup(): Q.Lookup<NewsletterPageTemplateRow> {
            return Q.getLookup<NewsletterPageTemplateRow>('NewsletterControl.NewsletterPageTemplate');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Newsletter:Contributor';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            NewsletterPageTemplateId = "NewsletterPageTemplateId",
            NewsletterId = "NewsletterId",
            PageTemplateId = "PageTemplateId",
            Rank = "Rank",
            TemplateSections = "TemplateSections",
            NewsletterNewsletterName = "NewsletterNewsletterName",
            NewsletterCreatedBy = "NewsletterCreatedBy",
            NewsletterDateCreated = "NewsletterDateCreated",
            NewsletterDateModified = "NewsletterDateModified",
            NewsletterModifiedBy = "NewsletterModifiedBy",
            NewsletterPages = "NewsletterPages",
            NewsletterStyleSheetId = "NewsletterStyleSheetId",
            PageTemplateTitle = "PageTemplateTitle",
            PageTemplateFileName = "PageTemplateFileName",
            PageTemplateRank = "PageTemplateRank",
            PageTemplateAdsSpots = "PageTemplateAdsSpots",
            PageTemplateNewsSpots = "PageTemplateNewsSpots",
            PageTemplateIsFilled = "PageTemplateIsFilled",
            IsFrontPage = "IsFrontPage"
        }
    }
}
